module.exports = require("url");


//////////////////
// WEBPACK FOOTER
// external "url"
// module id = 132
// module chunks = 0